export interface MovementStatusModel {
    value: MovementStatus
    text: string
}

export enum MovementStatus {
    pending = 0,
    confirmed = 1,
    all = 2
}